export const getFileNameWithoutExtension = (fileName) => {
  const fileNameDivided = fileName.split('.');
  fileNameDivided.pop();
  if (fileNameDivided.length > 1) {
    return fileNameDivided.join('.');
  }
  return fileNameDivided.join('');
};
